/** return true if two numbers are proximate (close to each other)
 *
 * - `a` — first number
 * - `b` — second number
 * - `e` — acceptable error
 */
export function proximate(a: number, b: number, e: number) {
    return Math.abs(a - b) <= e;
}

/** round a number up to decimal point */
export function round(n: number, d = 0): number {
    if (d === 0) return Math.round(n);
    else return Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
}

/** try to parse anything as number, otherwise returns the default */
export function parseOr(something: any, def = 0): number {
    const n = parseFloat(something);
    if (isNaN(n)) return def;
    else return n;
}

/** round number so that it is a multiple of `step` */
export function roundToMultiple(n: number, step: number): number {
    return Math.round(n/step) * step;
}

export function size(xs: any): number {
    if (xs === undefined || xs === null)
        return 0;
    switch (xs.constructor) {
        case Map:
        case Set:
            return (xs as Map<any, any> | Set<any>).size;

        case Array:
        case String:
            return (xs as Array<any>).length;

        default:
            return 0;
    }
}
